import clsx from 'clsx';
import NextLink, { LinkProps } from 'next/link';
import React, {
  AnchorHTMLAttributes,
  MouseEventHandler,
  ReactNode,
} from 'react';

import S from './StyledLink.module.scss';

export interface LinkType
  extends LinkProps,
    Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  className?: string;
  icon?: ReactNode;
  iconClassName?: string;
}

const StyledLink: React.FC<LinkType> = ({
  children,
  className,
  icon,
  iconClassName,
  onClick,
  ...rest
}) => {
  return onClick ? (
    <button
      onClick={onClick as unknown as MouseEventHandler<HTMLButtonElement>}
      className={clsx(S.StyledLink, className)}
    >
      {children}
    </button>
  ) : (
    <NextLink className={clsx(S.StyledLink, className)} {...rest}>
      {children}
      <span className={clsx(S.IconWrapper, iconClassName)}>{icon}</span>
    </NextLink>
  );
};

export default StyledLink;
